export default __webpack_public_path__ + "static/media/character_nft.3be4c45e.png";